import React from 'react'
import { OrderModel } from '../../../models/order';
import { Box, Button, Card, CardContent, Divider, IconButton, Typography, styled } from '@mui/material';
import { CartsModel } from '../../../models/carts';
import { PromotionTypeEnum } from '../../../enums/promotionType';
import { useTranslation } from 'react-i18next';
import PromotionText from '../../../components/PromotionText';
import { IMAGE_PRODUCTS_ROOT_URL } from '../../../constants/imageUrl';
import { EN_ACCEPT_LANGUAGE } from '../../../constants/acceptLanguageApi';
import { concatenateStrings } from '../../../utils/concatenateStrings';
import { numberFormat } from '../../../utils/nunberFormat';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

interface Props {
    selectedData: OrderModel
    carts: CartsModel[]
    onMinusProduct: (getCarts: CartsModel) => void
    onPlusProduct: (getCarts: CartsModel) => void
    onCheckAddedAllProduct: (getCarts: CartsModel) => boolean
    onPickProduct: (getCarts: CartsModel, quantity: number) => void
}

// Styled Components
const ProductImage = styled('img')({
    width: 120,
    height: 120,
    objectFit: 'cover',
    borderRadius: 8
});

const QuantityControl = styled(Box)(({ theme }) => ({
    backgroundColor: '#fff',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 150,
    padding: theme.spacing(0.5)
}));

const CardPackProduct = ({ selectedData, carts, onMinusProduct, onPlusProduct, onCheckAddedAllProduct, onPickProduct }: Props) => {
    const { t, i18n } = useTranslation('global')
    const getProductMap = new Map();
    const currentDate = new Date();
    selectedData?.carts?.forEach((item: CartsModel) => {
        const startDate = new Date(item?.product?.promotion?.startDate);
        if (item?.getProduct?.product?.itemcode && startDate <= currentDate) {
            const itemCode = item.getProduct.product.itemcode;
            if (getProductMap.has(itemCode)) {
                // getProductMap.get(itemCode).quantity += item.getProduct.quantity;
            } else {
                getProductMap.set(itemCode, { ...item.getProduct, quantity: item.getProduct.quantity });
            }
        }
    });

    return (
        <Box sx={{
            border: "1px solid #CBCBCB",
            borderRadius: "16px",
            padding: 2,

            mt: 2
        }}>
            {
                selectedData?.carts.map((item: CartsModel, index: number) => {
                    return (
                        <Card
                            key={index}
                            elevation={0}
                            sx={{
                                mb: 2,
                                border: '1px solid',
                                borderColor: 'grey.200',
                                borderRadius: 2,
                                bgcolor: '#f9f9f9'
                            }}
                        >
                            <CardContent>
                                {/* Promotion Badge */}
                                {/* {item?.getProduct !== null && startDate.getTime() <= currentDate.getTime() && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Typography variant="h6">{t("order_page.Promotion Type")}</Typography>
                                        {" "} : {" "}
                                        <PromotionText
                                            promotionType={item?.product?.promotion?.promotionType as PromotionTypeEnum}
                                            fontSize={20}
                                        />
                                    </Box>
                                )} */}
                                <Box sx={{ display: 'flex', gap: 3 }}>
                                    {/* Product Image */}
                                    <Box>
                                        <ProductImage
                                            src={IMAGE_PRODUCTS_ROOT_URL + item?.product?.price?.masterProduct?.mainImage?.url}
                                            alt=""
                                        />
                                    </Box>
                                    {/* Product Details */}
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="h6" gutterBottom>
                                            {i18n.language === EN_ACCEPT_LANGUAGE
                                                ? item?.product?.price?.masterProduct?.productNameEn
                                                : item?.product?.price?.masterProduct?.productNameLa}
                                        </Typography>

                                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Item code")}:
                                                </Box>{' '}
                                                {item?.product?.price?.masterProduct?.itemcode}
                                            </Typography>

                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Barcode")}:
                                                </Box>{' '}
                                                {concatenateStrings(item?.product?.price?.masterProduct?.barcodes)}
                                            </Typography>

                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Zone")}:
                                                </Box>{' '}
                                                {item?.product?.zone}
                                            </Typography>

                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Price")}:
                                                </Box>{' '}
                                                {numberFormat(item?.productPrice)} {t("Kip")}
                                            </Typography>
                                        </Box>
                                        <Typography variant="h6">
                                            <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                {t("order_page.Amount")}:
                                            </Box>{' '}
                                            <span style={{ color: 'red' }}> {numberFormat(item?.quantity)} </span>
                                        </Typography>
                                        {/* Quantity Control */}
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <QuantityControl>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onMinusProduct(item)}
                                                >
                                                    <RemoveIcon />
                                                </IconButton>
                                                <Typography>
                                                    {carts?.filter((subItem) =>
                                                        subItem?.product?.id === item?.product?.id
                                                    )?.[0]?.quantity || 0}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onPlusProduct(item)}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </QuantityControl>
                                            <Button
                                                variant="contained"
                                                color={onCheckAddedAllProduct(item) ? "error" : "primary"}
                                                onClick={() => onPickProduct(
                                                    item,
                                                    onCheckAddedAllProduct(item) ? 0 : item?.quantity
                                                )}
                                                sx={{
                                                    textTransform: 'none',
                                                    minWidth: 120
                                                }}
                                            >
                                                {onCheckAddedAllProduct(item)
                                                    ? t("order_page.Unpack all")
                                                    : t("order_page.Pack all")}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </CardContent>

                        </Card>
                    )
                })
            }

            {
                getProductMap.size > 0 && (
                    <Card sx={{
                        mt: 1, p: 2, borderRadius: '12px', bgcolor: '#f9f9f9',
                        boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
                    }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography variant="h6" sx={{ color: 'red' }}>{t("order_page.Promotion Product")}</Typography>
                        </Box>
                        {Array.from(getProductMap.values()).map((getProduct, index) => {
                            console.log(getProduct);

                            return (
                                <Box sx={{ display: 'flex', gap: 3 }} key={index}>
                                    <Box>
                                        <ProductImage
                                            src={IMAGE_PRODUCTS_ROOT_URL + getProduct?.product?.masterProduct?.mainImage?.url}
                                            alt=""
                                        />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="h6" gutterBottom>
                                            {i18n.language === EN_ACCEPT_LANGUAGE
                                                ? getProduct?.product?.masterProduct?.productNameEn
                                                : getProduct?.product?.masterProduct?.productNameLa}
                                        </Typography>

                                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Item code")}:
                                                </Box>{' '}
                                                {getProduct?.product?.itemcode}
                                            </Typography>

                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Barcode")}:
                                                </Box>{' '}
                                                {concatenateStrings(getProduct.product?.masterProduct?.barcodes)}
                                            </Typography>

                                            <Typography variant="body2">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Price")}:
                                                </Box>{' '}
                                                {numberFormat(getProduct.product.price)} {t("Kip")}
                                            </Typography>

                                            <Typography variant="h6">
                                                <Box component="span" sx={{ fontWeight: 'bold' }}>
                                                    {t("order_page.Amount")}:
                                                </Box>{' '}
                                                <span style={{ color: 'red' }}>{numberFormat(getProduct.quantity)}</span>
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            )
                        })}

                    </Card>
                )
            }

        </Box >
    )
}

export default CardPackProduct